import axios from "@/utils/axios";
import store from "..";

export default {
  namespaced: true,
  state: () => ({
    userConfig: {},
    wallPapers: {},
    credentials: null,
    theme: "auto", // auto | light | dark
  }),
  getters: {
    storeUserConfig: (state) => state.userConfig,
    storeWallPapers: (state) => state.wallPapers,
    storeCredentials: (state) => state.credentials,
    storeTheme: (state) => state.theme,
  },
  mutations: {
    setUserConfig(state, userConfig) {
      state.userConfig = userConfig;
    },
    setWallPapers(state, { type, wallPapers }) {
      state.wallPapers[type] = wallPapers;
    },
    setCredentials(state, credentials) {
      state.credentials = credentials;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
  },
  actions: {
    async fetchUserConfig({ commit }) {
      try {
        const response = await axios.get("/api/userConfig");
        commit("setUserConfig", response.data);
      } catch (error) {
        console.log(error);
        commit("setUserConfig", {});
      }
    },
    async fetchWallPapers({ commit }, { type, num = 1, source = "random" }) {
      try {
        const response = await axios.get(`/api/wallpaper?num=${num}&source=${source}`);
        const wallpapers = response.data.data;
        const wallPapers = wallpapers.map((wallpaper) => wallpaper.url);
        commit("setWallPapers", { type, wallPapers });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
